import React from 'react';
import { PLUGIN_TOOLBAR_BUTTON_ID } from 'wix-rich-content-editor-common';
import {
  DeleteButton,
  NodeAlignmentButton,
  NodeSizeButton,
  ReplaceButton,
  SettingsButton,
  ToolbarButtonSeparator,
} from 'wix-rich-content-toolbars-ui';
import { NodeLinkButton } from 'wix-rich-content-toolbars-v3';

export const toolbarButtonsRenders = {
  [PLUGIN_TOOLBAR_BUTTON_ID.DELETE]: toolbarItem => {
    return <DeleteButton toolbarItem={toolbarItem} />;
  },
  [PLUGIN_TOOLBAR_BUTTON_ID.ALIGNMENT]: toolbarItem => {
    return (
      <NodeAlignmentButton toolbarItem={toolbarItem} id={PLUGIN_TOOLBAR_BUTTON_ID.ALIGNMENT} />
    );
  },
  [PLUGIN_TOOLBAR_BUTTON_ID.SIZE]: toolbarItem => {
    return <NodeSizeButton toolbarItem={toolbarItem} id={PLUGIN_TOOLBAR_BUTTON_ID.SIZE} />;
  },
  [PLUGIN_TOOLBAR_BUTTON_ID.SETTINGS]: toolbarItem => {
    return <SettingsButton toolbarItem={toolbarItem} />;
  },
  [PLUGIN_TOOLBAR_BUTTON_ID.REPLACE]: toolbarItem => {
    return <ReplaceButton toolbarItem={toolbarItem} />;
  },
  [PLUGIN_TOOLBAR_BUTTON_ID.LINK]: toolbarItem => {
    return <NodeLinkButton toolbarItem={toolbarItem} />;
  },
  [PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR]: () => {
    return <ToolbarButtonSeparator />;
  },
};
